window.addEventListener("load", () => {
  
  // YMK code
  window.ymkAsyncInit = function () {
    window.YMK.init({
      autoOpen: false,
      width: 300,
      height: 600,
    });
 window.YMK.addEventListener("opened", function () {
    console.log("opened");
    
    // Get the SKU of the default selected swatch
    const defaultSwatch = document.querySelector(".swatch-element.active, .swatch-element.selected");
    if (defaultSwatch) {
        const sku = defaultSwatch.getAttribute("data-variant-sku");
        if (sku) {
            YMK.applyMakeupBySku(sku);
            console.log("Auto-applied SKU:", sku);
        }
    }

    setTimeout(function () {
        if (window.innerWidth < 768) {
            document.querySelector(".product-wrapped").style.height =
                document.querySelector("#YMK-module iframe").offsetHeight + "px";
        }
    }, 500);
});


    window.YMK.addEventListener("reset", function () {});
    window.YMK.addEventListener("compare", function () {});
    window.YMK.addEventListener("videoLoaded", function () {
      console.log("videoLoaded");
    });
    window.YMK.addEventListener("photoLoaded", function () {
      console.log("photoLoaded");
    });
    window.YMK.addEventListener("loaded", function () {
      console.log("loaded");
    });
    window.YMK.addEventListener("shadeFinderComplete", function (r) {
      console.log("shadeFinderComplete", r);
    });
  };

  function snapshot2blob() {
    window.YMK.snapshot("blob", function (result) {
      //console.log('results', result);
    });
  }
  function snapshot2base64() {
    window.YMK.snapshot("base64", function (result) {
      //console.log('results', result);
    });
  }

  function loadImage() {
    var file = document.getElementById("imageData").files[0];
    if (file) {
      window.YMK.open(file);
    }
  }

  function applyMakeupManual() {
    const itemGuid = document.getElementById("itemGuid");
    YMK.applyMakeupBySku(itemGuid.value);
    console.log(itemGuid.value)
  }

  function applyLookManual() {
    const lookGuid = document.getElementById("lookGuid");
    YMK.applyMakeupByLook(lookGuid.value);
     console.log(lookGuid.value)
  }
});

// Try on Module Code For PDP Page Starts By Surjeet
document.addEventListener('DOMContentLoaded', function () {
const parent = document.querySelector('body');
const TryonBtn = document.querySelectorAll('.tryBtn')
const windwInnerWidth = window.innerWidth;
window.addEventListener('scroll',()=>{
  if(windwInnerWidth < 768 ){
    const scrollHeight = window.scrollY;
    const TryONModuleImage = document.querySelector('.activeImg');
    const TryOnModuleBtns = document.querySelector('.tryBtns');
    if(scrollHeight <= 300){
      if(TryONModuleImage){
      TryONModuleImage.style.display = 'none';
      }
      if(TryOnModuleBtns){
      TryOnModuleBtns.style.display = 'flex';
      }
    }
    else{
      if(TryONModuleImage){
      TryONModuleImage.style.display = 'block';
      }
      if(TryOnModuleBtns){
      TryOnModuleBtns.style.display = 'none';
      }
    }
  }
})

const YMKInitModule = (params) =>{
  window.scrollTo(0,0);
   YMK.init({
      autoOpen: true,
    });
    document.body.classList.add('tryOnOpen');
  document.querySelectorAll('.tryONModuleBox').forEach((item) =>{
    item.style.display = 'block';
  });
  TryonBtn.forEach((item) =>{
    item.classList.add('closeTryOn');
    item.textContent = 'Close';
    item.classList.remove('tryItonBtn');
  })
  //     document.querySelectorAll('.swatch-element').forEach((item) => {
  // item.classList.add('try-on-open');
// });

  // if(windwInnerWidth > 768){
  //   document.querySelectorAll('.imgWrapper').forEach((item) =>{
  //     item.style.display = 'none';
  //   });
  // }
  //   else{
  //   document.querySelectorAll('.pr_lg_img').forEach((item) =>{
  //     // item.style.display = 'none';
  // });
  
  //      const elementsToOrder = document.querySelectorAll(".product-single__title, .productPrice, .shopify-app-block, .product-single__description");
  // elementsToOrder.forEach(element => {
  //   element.style.order = '3';
  // });
    // }
 
}

const YMKRemoveModule = (params) =>{
  window.scrollTo(0,0);
   document.body.classList.remove('tryOnOpen');
  document.querySelectorAll('.tryONModuleBox').forEach((item) =>{
    item.style.display = 'none';
  });
  TryonBtn.forEach((item) =>{
     item.classList.remove('closeTryOn');
     item.textContent = 'Try On';
     item.classList.add('tryItonBtn');
  })
  //       document.querySelectorAll('.swatch-element').forEach((item) => {
  // item.classList.remove('try-on-open');
// });
  //   if(windwInnerWidth > 768){
  //   document.querySelectorAll('.imgWrapper').forEach((item) =>{
  //     item.style.display = 'block';
  //   });
  // }
  //   else{
  //   document.querySelectorAll('.pr_lg_img').forEach((item) =>{
  //     item.style.display = 'block';
  // });


  //      const elementsToOrder = document.querySelectorAll(".product-single__title, .productPrice, .shopify-app-block, .product-single__description");
  // elementsToOrder.forEach(element => {
  //   element.style.order = '0';
  // });
  //   }
}

parent.addEventListener('click',(event) =>{
  if(event.target.classList.contains('tryItonBtn') || event.target.classList.contains('trynowImage') ){
    YMKInitModule();

    const tryNowImage = document.querySelector('.trynowImage');
    if (tryNowImage) {
      tryNowImage.classList.remove('activeImg');
      tryNowImage.style.display = "none";
    }

    const closeNowImage = document.querySelector('.CloseNowImage');
    if (closeNowImage) {
      closeNowImage.classList.add('activeImg');
      closeNowImage.style.display = "block";
    }
  }
  else if(event.target.classList.contains('closeTryOn') || event.target.classList.contains('CloseNowImage') ){
    YMKRemoveModule();

    const closeNowImage = document.querySelector('.CloseNowImage');
    if (closeNowImage) {
      closeNowImage.classList.remove('activeImg');
      closeNowImage.style.display = "none";
    }

    const tryNowImage = document.querySelector('.trynowImage');
    if (tryNowImage) {
      tryNowImage.classList.add('activeImg');
      tryNowImage.style.display = "block";
    }
  }
});

if(document.querySelector('.tryImg')){
  document.querySelector('.tryImg').addEventListener('click',(event)=>{
   event.target.classList.add('closetryImg');
   event.target.classList.remove('tryImg');
    YMKInitModule();
    
  })
}
  if(document.querySelector('.closetryImg')){
    document.querySelector('.closetryImg').addEventListener('click',(event)=>{
   event.target.classList.remove('closetryImg');
   event.target.classList.add('tryImg');
    YMKRemoveModule();
    
  })
  }
});


//  Try on Module Code For PDP Page Ends By Surjeet

document.addEventListener("DOMContentLoaded", function () {
    const swatches = document.querySelectorAll(".swatch-element");

    const tryOnCardTitle = document.querySelectorAll(".try-on-open-selected-variant-box-title");
    const tryOnCardName = document.querySelectorAll(".try-on-open-selected-variant-box-variant-name");
    const tryOnCardPrice = document.querySelectorAll(".try-on-open-selected-variant-box-variant-price");
    const tryOnCardImg = document.querySelectorAll(".try-on-open-selected-variant-box-img img");
    const tryOnCardBtnPrice = document.querySelectorAll(".try-on-open-atc .m_productPrice");
    const tryOnCardBtnId = document.querySelectorAll(".try-on-open-atc .product-form input[name='id']");
    const tryOnCardATCBtn = document.querySelectorAll(".try-on-open-atc .atcMainBtn");
    const tryOnCardATCBtnTitle = document.querySelectorAll(".try-on-open-atc .atcMainBtn .m_atcBtn .txt.removeUnavailable");

    swatches.forEach(function (swatch) {
        swatch.addEventListener("click", function () {
           // Remove 'selected' from all
        document.querySelectorAll('.try-on-open-swatchLbl-variant-box')
            .forEach(el => el.classList.remove('selected'));

        // Add 'selected' only to the clicked one
        this.querySelector('.try-on-open-swatchLbl-variant-box')
            ?.classList.add('selected');

          // this.querySelector('.try-on-open-swatchLbl-variant-box')?.classList.add('selected');
            const swatchSKU = this.getAttribute("data-variant-sku");
            const variantID = this.getAttribute("data-variant-id");
            const swatchIMG = this.getAttribute("data-variant-img");
            const swatchPrice = this.getAttribute("data-variant-price"); // lowercase "price" to match HTML attribute conventions
            const productTitle = this.getAttribute("data-product-title");
            const swatchTitle = this.getAttribute("data-value");
            const swatchAvailability = this.getAttribute("data-variant-availability");
            
              YMK.applyMakeupBySku(swatchSKU);

            if (swatchAvailability !== 'true') {
    tryOnCardATCBtn.forEach(btn => {
        btn.classList.add('sold-out');
        btn.setAttribute('disabled', 'disabled');
        // btn.textContent = 'SOLD OUT';
    });
    tryOnCardATCBtnTitle.forEach(btn => { btn.textContent = 'SOLD OUT'; });
} else {
    tryOnCardATCBtn.forEach(btn => {
        btn.classList.remove('sold-out');
        btn.removeAttribute('disabled');
        // btn.textContent = 'ADD TO CART';
    });
    tryOnCardATCBtnTitle.forEach(btn => { btn.textContent = 'ADD TO CART'; });
}

            // Update text content
            tryOnCardTitle.forEach(el => el.textContent = productTitle);
            tryOnCardName.forEach(el => el.textContent = swatchTitle);
            tryOnCardPrice.forEach(el => el.textContent = swatchPrice);
            tryOnCardBtnPrice.forEach(el => el.textContent = swatchPrice);

            // Update image
            tryOnCardImg.forEach(el => el.src = swatchIMG);

            // Update hidden input value
            tryOnCardBtnId.forEach(el => el.value = variantID);
        });
    });

    var swatch_elementDefault = document.querySelector(".swatch-element.default");

if (swatch_elementDefault) {
  var swatch_elementDefaultSKU = swatch_elementDefault.getAttribute("data-variant-sku");
  console.log("swatch_elementDefaultSKU", swatch_elementDefaultSKU);

  const oldLog = console.log;
  console.log = function (...args) {
    if (args.some(a => typeof a === "string" && a.includes("face_detect_model_path"))) {
      oldLog("🎯 YMK module just loaded!", swatch_elementDefaultSKU);

      // Wait 3 seconds before applying makeup
      setTimeout(() => {
        YMK.applyMakeupBySku(swatch_elementDefaultSKU);
      }, 1000);
    }
    oldLog.apply(console, args);
  };
}


});


  